import i18n from "@/i18n"

import SyncDrafts from "./syncList/SyncDrafts"
import SyncSettings from "./syncList/SyncSettings.vue"
import SyncList from "./syncList"
import SyncRules from "./SyncRules"

export default {
  path: "/sync",
  component: () => import("./index.vue"),
  redirect: { name: "sync-list" },
  name: "sync",
  meta: {
    title: i18n.t("synchronization.title")
  },
  children: [
    {
      path: "sync-list",
      name: "sync-list",
      component: SyncList,
      meta: {
        title: i18n.t("synchronization.sub_title_1")
      }
    },
    {
      path: "sync-create",
      name: "sync-create",
      component: SyncSettings,
      props: { editMode: false },
      meta: {
        title: i18n.t("synchronization.create_sync_title"),
        returnButtonName: "sync-list"
      }
    },
    {
      path: "sync-settings/:uuid",
      name: "sync-settings",
      component: SyncSettings,
      props: { editMode: true },
      meta: {
        title: i18n.t("synchronization.update_sync_title"),
        returnButtonName: "sync-list"
      }
    },
    {
      path: "sync-drafts/:uuid",
      name: "sync-drafts",
      component: SyncDrafts,
      meta: {
        title: i18n.t("synchronization.information_about_file"),
        returnButtonName: "sync-list"
      }
    },
    {
      path: "sync-rules",
      name: "sync-rules",
      component: SyncRules,
      meta: {
        title: i18n.t("synchronization.sub_title_2")
      }
    }
  ]
}
